import React from "react";
import { useSelector } from "react-redux";
import MovieCard from "../movie/MovieCard";

const LikesPage = () => {
  const items = useSelector((s) => s.likes.items);
  const movies = Object.values(items).sort((a, b) => b.likedAt - a.likedAt);

  return (
    <div className="container mt-4 mb-5">
      <h2 className="mb-1">
        <i className="fas fa-heart text-danger mr-2"></i>
        Liked Movies
      </h2>
      <p className="text-muted mb-4">{movies.length} movies</p>

      {movies.length === 0 ? (
        <div className="empty-state">
          <i className="far fa-heart"></i>
          <h4>No liked movies yet</h4>
          <p>Search for movies and hit the heart to add them here.</p>
        </div>
      ) : (
        <div className="movie-grid">
          {movies.map((movie) => (
            <MovieCard key={movie.imdbID} movie={movie} />
          ))}
        </div>
      )}
    </div>
  );
};

export default LikesPage;
